import { setupWorker } from 'msw/browser'

import { env } from '@/env'

export const worker = setupWorker()

export async function enableMSW() {
  if (!env.VITE_ENABLE_MSW) {
    return
  }

  await worker.start()
}
